// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "app/styles/" + chunkId + "." + {"1034":"66574bb4c05941b25f61","7852":"b145044b15063ba835d6"}[chunkId] + ".css";
};